import { render } from "./GuidePubSetting.vue?vue&type=template&id=13be015c"
import script from "./GuidePubSetting.vue?vue&type=script&lang=js"
export * from "./GuidePubSetting.vue?vue&type=script&lang=js"

import "./GuidePubSetting.vue?vue&type=style&index=0&id=13be015c&lang=css"

import exportComponent from "/workspace/goj/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__